/**
 *
 *
 *
 *
 *
 *
 */

import { useSyncExporter } from "../common/useSyncExporter.js";
import { cookieSync, type CookieSync } from "../globals/cookie.js";


export type { SamesiteValues, SetCookieOptions, RemoveCookieOptions } from "../lib/cookie/head.js";

const asExport = useSyncExporter(({ o_util }) => o_util.cookie);

/**
 *
 *
 *
 */
export const exists: CookieSync["exists"] = asExport("exists");

/**
 *
 *
 *
 */
export const get: CookieSync["get"] = asExport("get");

/**
 *
 *
 *
 */
export const remove: CookieSync["remove"] = asExport("remove");

/**
 *
 *
 *
 */
export const set: CookieSync["set"] = asExport("set");

/*                */
export {
  /*                                                                     */
  cookieSync as cookie,
};
